import { useSections } from "@/contexts/classified";
export const useEnergy = () => {
    var _a;
    const energy = (_a = useSections()) === null || _a === void 0 ? void 0 : _a.energy;
    const { certificates, features, hasScales } = energy || {};
    const maximumDisplayedCertificates = certificates === null || certificates === void 0 ? void 0 : certificates.slice(0, 2);
    const hasCertificates = certificates && certificates.length > 0;
    const hasFeatures = features && features.length > 0;
    const hasData = hasScales || hasCertificates || hasFeatures;
    return {
        certificates,
        features,
        hasScales,
        hasData,
        maximumDisplayedCertificates,
    };
};
